module.exports = __webpack_public_path__ + "media/images/honeyfarm/Log hives-4474171c3295e20de0affe22dc3cd1d7.jpg";